import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AuthLayout from "./components/AuthLayout";
import LoginForm from "./components/LoginForm";
import SignUpForm from "./components/SignUpForm";
import ForgotPassword from "./components/ForgotPassword";
import DashboardLayout from "./components/DashboardLayout";
import UserDashboardIndex from "./components/UserDashboardIndex";
import SignalList from "./components/SignalList";
import ReferenceLog from "./components/ReferenceLog";
import ProfileSettings from "./components/ProfileSettings";
import ChangePassword from "./components/ChangePassword";
import SupportTicket from "./components/SupportTicket";
import CreateTicketContext from "./context/CreateTicketContext";
import CreateUserDataContext from "./context/CreateUserDataContext";
import Otp from "./components/Otp";
import RegisterSuccessful from "./context/RegisterSuccessful";
import IntrestedUsers from "./pages/intrestedUsers";
import Hidepopup from "./context/Hidepopup";

export default function App() {
  return (
    <RegisterSuccessful>
      <CreateTicketContext>
        <CreateUserDataContext>
          <>
            <Router>
              <Routes>
                <Route
                  path="/"
                  element={
                    <Hidepopup>
                      <LandingPage />
                    </Hidepopup>
                  }
                />
                <Route path="/auth" element={<AuthLayout />}>
                  <Route index element={<LoginForm />} />
                  <Route path="login" element={<LoginForm />} />
                  <Route path="signup" element={<SignUpForm />} />
                  <Route path="forgot-password" element={<ForgotPassword />} />
                  <Route path="otp" element={<Otp />} />
                </Route>
                <Route path="/dashboard" element={<DashboardLayout />}>
                  <Route index element={<UserDashboardIndex />} />
                  <Route path="signals" element={<SignalList />} />
                  <Route path="reference" element={<ReferenceLog />} />
                  <Route
                    path="profile/settings"
                    element={<ProfileSettings />}
                  />
                  <Route
                    path="profile/change/password"
                    element={<ChangePassword />}
                  />
                  <Route path="supportticket" element={<SupportTicket />} />
                </Route>
                <Route
                  path="/newsletter"
                  element={
                    <Hidepopup>
                      <IntrestedUsers />
                    </Hidepopup>
                  }
                />
              </Routes>
            </Router>
          </>
        </CreateUserDataContext>
      </CreateTicketContext>
    </RegisterSuccessful>
  );
}
